// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"35":"ba8f4e47","793":"d542e9d7","843":"71a85863"}[chunkId] + ".css";
};